import { React } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import {
  AiFillGithub,
  AiFillInstagram,
  AiOutlineTwitter,
} from 'react-icons/ai';
import { FaLinkedinIn } from 'react-icons/fa';
import myImg from '../../assets/images/avatar.svg';
function PersonalInfo() {
  return (
    <Container fluid className=" home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: '2.6em' }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I love programming.&hearts; <br />I have completed Bachelor of
              Engineering in{' '}
              <i>
                <b className="purple">Computer Science and Engineering </b>{' '}
              </i>{' '}
              from Comilla University. <br />I have 7+ years of working
              experience in{' '}
              <i>
                <b className="purple">Web Development. </b>
              </i>{' '}
              <br />
              Now I live in japan and working as a{' '}
              <i>
                <b className="purple">software engineer(web).</b>
              </i>{' '}
              <br />I have 5+ years of working experience in Japan as a{' '}
              <i>
                <b className="purple">software engineer(web). </b>
              </i>
              <br />
              <br />
              <br />I have strong knowledge in
              <i>
                <b className="purple"> Javascript , PHP , HTML, CSS, MySQL. </b>
              </i>
              <br />I have working experience using{' '}
              <i>
                <b className="purple">git, docker, vscode </b>
              </i>
              <br />
              <br />
              <br />
              My field of Interest&apos;s are in developing, maintaing and
              upgrading &nbsp;
              <i>
                <b className="purple">Web Application. </b>
              </i>
              <br />
              <br />I am very interested to developing web application with
              <i>
                <b className="purple">
                  {' '}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple">
                  {' '}
                  Next.js (React.js framework), Redux.js , Laravel.
                </b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <img src={myImg} className="img-fluid" alt="avatar" />
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Prasanto19"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/prasanto19/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/Prasanto19"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/prasanto19/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default PersonalInfo;
